import { ROUTES } from 'routes/constants';

export const SidebarMenuItemLinkMap: Record<string, string | (() => string)> = {
  // Admin Management Routes
  ['/admin-users']: ROUTES.adminUsers,
  ['/admin-roles']: ROUTES.adminRoles,
  ['/audit-logs']: ROUTES.adminLogs,

  // Admin Create Routes
  ['/admin-users/create']: ROUTES.createAdminUser,
  ['/admin-roles/create']: ROUTES.createAdminRole,

  // GCash Routes
  ['/gcash/home']: ROUTES.gcashHomePage,
  ['/gcash/applications']: ROUTES.gcashApplications,
  ['/gcash/reports']: ROUTES.gcashReports,
  ['/gcash/activities']: ROUTES.gcashActivities,

  // Other Routes
  ['/verify-email']: ROUTES.verifyEmail,
  ['/test-error-page']: ROUTES.testErrorPage,
  ['/']: ROUTES.home,
};
